export default function JurisdictionTable({ jurisdictions, transitNights }) {
  return (
    <div className="rounded-card border border-hairline bg-surface h-full flex flex-col" data-testid="jurisdiction-table">
      <div className="px-5 py-4 border-b border-sand-200">
        <p className="label-tag">Presence by jurisdiction</p>
        <p className="text-xs text-sand-500 mt-1">
          Days = any part of day · Nights = where you slept
        </p>
      </div>
      {(!jurisdictions || jurisdictions.length === 0) ? (
        <p className="px-5 py-8 text-sm text-sand-500">No presence data yet. Upload flight history below.</p>
      ) : (
        <div className="flex-1">
          <div className="grid grid-cols-[1fr_70px_70px] px-5 py-2 border-b border-sand-100">
            <span className="label-tag text-[9px]">Jurisdiction</span>
            <span className="label-tag text-[9px] text-right">Days</span>
            <span className="label-tag text-[9px] text-right">Nights</span>
          </div>
          {jurisdictions.map((j) => {
            const isPR = j.code === "US-PR";
            return (
              <div
                key={j.code}
                className={`grid grid-cols-[1fr_70px_70px] px-5 py-2.5 border-b border-sand-50 ${isPR ? "bg-ember/[0.04]" : ""}`}
                data-testid={`jurisdiction-row-${j.code}`}
              >
                <span className={`text-sm truncate ${isPR ? "font-semibold text-ember" : "text-sand-800"}`}>
                  {j.name} <span className="font-mono text-[10px] text-sand-400 ml-1">{j.code}</span>
                </span>
                <span className="font-mono text-sm text-right text-sand-900">{j.days}</span>
                <span className="font-mono text-sm text-right text-sand-600">{j.nights}</span>
              </div>
            );
          })}
          {transitNights > 0 && (
            <div className="grid grid-cols-[1fr_70px_70px] px-5 py-2.5">
              <span className="text-sm text-sand-500 italic">In transit (red-eyes)</span>
              <span />
              <span className="font-mono text-sm text-right text-sand-500">{transitNights}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
